import { Errors } from "@/interfaces";

export class ErrorUtility {
    public static HandleError(error: any, boundedErrorKeys: string[] = []): Errors {
        const result: Errors = {
            boundErrors: [],
            alerts:[]
        };

        const errorCode = error?.response?.status;

        switch(errorCode) {
            case 500: {
                result.alerts.push('Internal Server error occurred.');
                break;
            }

            case 400: {
                let errorData: any;

                if (error?.response?.data?.errors) {
                    errorData = error?.response?.data?.errors;
                } else if (error?.response?.data) {
                    errorData = error?.response?.data;
                }

                if (!Array.isArray(errorData) && typeof(errorData) === 'object') {
                    const propertyNames = Object.getOwnPropertyNames(errorData);
                    propertyNames.forEach(p => {
                        if(p){
                            // bounded error property name should be in CamelCase
                            const camelCaseName = /[A-Z]/.test(p[0]) ? p.replace(/^\w/, (c) => c.toLowerCase()) : p;
                            const isArrayError = camelCaseName.indexOf('[') > -1 && camelCaseName.indexOf(']') > -1;

                            if(boundedErrorKeys.includes(camelCaseName) || isArrayError){
                                result.boundErrors[camelCaseName] = errorData[p];
                            } else {
                                result.alerts.push(errorData[p]);
                            }
                        } else {
                            result.alerts.push(errorData[p]);
                        }
                    });
                } else {
                    result.alerts.push(errorData);
                }

                break;
            }

            case 401: {
                if(error?.response?.data[""]?.errors) {
                    const errorData = error?.response?.data[""]?.errors;
                    errorData.forEach((e: any) => {
                        const errorMessage = e.errorMessage;
                        if (errorMessage) {
                            result.alerts.push(errorMessage);
                        }
                    });
                } else {
                    result.alerts.push("Unknown error occurred.");
                }

                break;
            }

            case 404: {
                result.alerts.push("The requested resource was not found.");
                break;
            }

            default: {
                result.alerts.push('Unknown error occurred.');
                break;
            }
        }

        return result;
    }
}
